export const SPOTTER_ORIGIN_HEADER = {
    ORIGIN: 'x-ba-request-origin',
    ORIGIN_DETAIL: 'x-ba-request-origin-detail',
};
export const SPOTTER_ORIGIN = {
    SPOTTER: 'spotter',
    EMBED: 'embed',
};
export const SPOTTER_ORIGIN_DETAIL = {
    SPOTTER_PAGE: 'spotter_page',
    HOME_PAGE: 'home_page',
    LIVEBOARD: 'liveboard',
    DATA_APP: 'data_app',
    ANALYST_BUILDER: 'analyst_builder',
};
//# sourceMappingURL=spotter-origin.js.map